'use strict';

const _=require('pulsar-utils/dist-es6/_');
const d3=require('d3');
const PersonStatisticsViewModel=require('../../../dist-es6/client/viewModels/personStatisticsViewModel');
const IncidentViewModel=require('../../../dist-es6/client/viewModels/incidentViewModel');
const Formatters=require('../../../dist-es6/client/formatters');
const ForecastPersonViewModel=require('../../../dist-es6/client/viewModels/forecastPersonViewModel');
const BaseDirective=require('../../../dist-es6/client/angularCommon/baseDirective');
const ThresholdStatus=require('pulsar-dashboard-core/dist-es6/domain/thresholdStatus');let

SparklineDirective=class SparklineDirective extends BaseDirective{
get restrict(){
return'E';
}

get objectBindings(){
return['viewModel','selectedNotificationType','svgWidth','svgHeight'];
}

link(scope,element){
const svgWidth=scope.svgWidth?Number(scope.svgWidth):350;
const svgHeight=scope.svgHeight?Number(scope.svgHeight):46;
const minFatigueValue=3;
const maxFatigueValue=25.5;

const sparklineGraph=new SparklineGraph(element,svgWidth,svgHeight,minFatigueValue,maxFatigueValue);

scope.$watchGroup(['viewModel','selectedNotificationType'],newlySelectedNotificationType=>{
sparklineGraph.redraw(scope.selectedNotificationType,scope.viewModel);
});
}};let


SparklineGraph=class SparklineGraph{
constructor(element,svgWidth,svgHeight,minFatigueValue,maxFatigueValue){
this._element=element;
this._svgWidth=svgWidth;
this._svgHeight=svgHeight;
this._minFatigueValue=minFatigueValue;
this._maxFatigueValue=maxFatigueValue;

this._deviationMarkerHeight=16;
this._thresholdLineOffset=0.5;
this._midpointY=this._svgHeight/2;

this._xScale=d3.scale.linear().
domain([this._minFatigueValue,this._maxFatigueValue]).
range([0,this._svgWidth]);

this._singleUnitWidthInPixels=Math.ceil(this._xScale(2)-this._xScale(1));

this._element.append(`<svg width="${this._svgWidth}" height="${this._svgHeight}"></svg>`);
this._svg=d3.select(this._element[0].getElementsByTagName('svg')[0]);

this._axisGroup=this._svg.append('g').attr({class:'axis'});
this._deviationRangeGroup=this._svg.append('g').attr({class:'deviation-range'});
this._effectiveThresholdGroup=this._svg.append('g').attr({class:'effective-threshold'});
this._currentFatigueGroup=this._svg.append('g').attr({class:'fatigue-points'});
this._peakWorkdayFatigueGroup=this._svg.append('g').attr({class:'peak-forecast'});
}

_getXPositionFor(thresholdValue,offset=0,isRounded=!0){
let clampedDomainValue=_.clamp(thresholdValue,this._minFatigueValue+offset,this._maxFatigueValue+offset);
let nonIntegerRangeValue=this._xScale(clampedDomainValue-offset);
return isRounded?Math.round(nonIntegerRangeValue):nonIntegerRangeValue;
}

_getRequiredData(viewModel,selectedNotificationType){
if(viewModel instanceof PersonStatisticsViewModel){
return{
averageDailyLow:viewModel.averageDailyLow,
averageDailyHigh:viewModel.averageDailyHigh,
topDailyHighs:viewModel.topDailyHighs,
effectiveThreshold:viewModel.thresholdFor(selectedNotificationType)};

}

if(viewModel instanceof IncidentViewModel){
return{
averageDailyLow:_.get(viewModel,'statistics.recentHistory.fatigue.averageDailyLow'),
averageDailyHigh:_.get(viewModel,'statistics.recentHistory.fatigue.averageDailyHigh'),
topDailyHighs:_.get(viewModel,'statistics.recentHistory.fatigue.topDailyHighs'),
effectiveThreshold:viewModel.thresholdFor(selectedNotificationType)};

}

throw new Error(`[${this.constructor.name}] Expected either view model of type 'PersonStatisticsViewModel' or 'IncidentViewModel' - got ${viewModel.constructor.name}`);
}

_drawDeviationRangeAndEffectiveThreshold(viewModel,selectedNotificationType){
if(!_.exists(viewModel)){
return!1;
}

const{
averageDailyLow,
averageDailyHigh,
topDailyHighs,
effectiveThreshold}=
this._getRequiredData(viewModel,selectedNotificationType);

let drawXAxis=!1;

if(_.allExist(averageDailyLow,averageDailyHigh)){
let deviationRangeMin=Math.floor(averageDailyLow);
let deviationRangeMax=Math.ceil(averageDailyHigh);

const deviationRangeLine=this._deviationRangeGroup.
selectAll(`line`).
data([{deviationRangeMin,deviationRangeMax}]);

deviationRangeLine.
enter().
append('line').
style({
"stroke-width":this._singleUnitWidthInPixels*0.7,
stroke:'#C3CDCF'});


deviationRangeLine.
exit().
remove();

deviationRangeLine.
transition().duration(200).
attr({
x1:({deviationRangeMin})=>this._getXPositionFor(deviationRangeMin,this._thresholdLineOffset)-0.5,
x2:({deviationRangeMax})=>this._getXPositionFor(deviationRangeMax,this._thresholdLineOffset)-0.5,
y1:this._midpointY,
y2:this._midpointY,
class:'deviation-range'});

}else{
this._deviationRangeGroup.
selectAll(`line`).
remove();
}

if(_.exists(effectiveThreshold)){
drawXAxis=!0;
let deviationThresholdX=this._getXPositionFor(effectiveThreshold,this._thresholdLineOffset)-0.5;
let markerHalfHeight=this._deviationMarkerHeight/2;

let isWithinVisibleRange=deviationThresholdX<this._svgWidth;
if(!isWithinVisibleRange){
deviationThresholdX=this._svgWidth-1;
}

const deviationThresholdLine=this._effectiveThresholdGroup.
selectAll(`line`).
data([deviationThresholdX].filter(value=>_existsAndIsANumber(value)));

deviationThresholdLine.
enter().
append('line').
style({
"stroke-width":1,
stroke:isWithinVisibleRange?
'#6A8187':
'#DE1A1C'});


deviationThresholdLine.
exit().
remove();

deviationThresholdLine.
transition().duration(200).
attr({
x1:value=>value,
x2:value=>value,
y1:this._midpointY-markerHalfHeight,
y2:this._midpointY+markerHalfHeight,
class:'deviation-threshold'});

}else{
this._effectiveThresholdGroup.
selectAll(`line`).
remove();
}

return drawXAxis;
}

_drawFatiguePoints(group,data,thresholdStatus){
let thresholdStatusClass=Formatters.classFromThresholdStatus(thresholdStatus);
let currentFatiguePoint=group.
selectAll('circle').
data(data.filter(({value})=>_existsAndIsANumber(value)));

currentFatiguePoint.
enter().
append('circle').
attr({r:0});

currentFatiguePoint.
exit().
transition().duration(200).
attr({r:0}).
each('end',_removeElement);

currentFatiguePoint.
transition().duration(200).
attr({
cx:({value})=>this._getXPositionFor(Math.floor(value),0,!0),
cy:this._midpointY,
r:({additionalClasses=[]})=>{
if(additionalClasses.find(c=>c==='peak-forecast')!==void 0){
return 5;
}

if(additionalClasses.find(c=>c==='peak-forecast-outline')!==void 0){
return 7;
}

return this._singleUnitWidthInPixels/2;
},
class:({additionalClasses=[]})=>_(thresholdStatusClass).
mapValues((isTrue,className)=>isTrue?className:'').
values().concat(additionalClasses).
join(' ').trim()});


}

_drawXAxis(){
if(this._axisDrawn){
return;
}

let xAxis=this._axisGroup.
insert('line',':first-child').
attr({
x1:0,
x2:this._svgWidth,
y1:this._midpointY,
y2:this._midpointY,
class:'x-axis'}).

style({
"stroke-width":3,
stroke:'#E1E6E7'});


this._axisDrawn=!0;
}

_clearPlottedFatiguePoints(group){
this._drawFatiguePoints(group,[],ThresholdStatus.NotApplicable);
}

redraw(selectedNotificationType,viewModel){
let drawXAxis=this._drawDeviationRangeAndEffectiveThreshold(viewModel,selectedNotificationType);

if(viewModel instanceof ForecastPersonViewModel){
drawXAxis=!0;

if(_.exists(viewModel,'currentStatus')){
const pointPlotData=[{value:viewModel.currentStatus.fatigue}];

this._drawFatiguePoints(this._currentFatigueGroup,pointPlotData,viewModel.currentStatus.thresholdStatus);
}else{
this._clearPlottedFatiguePoints(this._currentFatigueGroup);
}

if(_.exists(viewModel,'peakWorkdayFatigue')){
const peakWorkdayFatigue=viewModel.peakWorkdayFatigue;
const thresholdStatus=ThresholdStatus.fromScoreAndThreshold(peakWorkdayFatigue,viewModel.currentThreshold);
const pointPlotData=[{
value:peakWorkdayFatigue,
additionalClasses:['peak-forecast-outline']},
{
value:peakWorkdayFatigue,
additionalClasses:['peak-forecast']}];


this._drawFatiguePoints(this._peakWorkdayFatigueGroup,pointPlotData,thresholdStatus);
}else{
this._clearPlottedFatiguePoints(this._peakWorkdayFatigueGroup);
}

}else if(viewModel instanceof IncidentViewModel&&_.exists(viewModel.fatigue)){
drawXAxis=!0;

this._setupFatiguePointFor(viewModel.fatigue,viewModel,selectedNotificationType);
}else if(_.exists(viewModel,'lastKnownStatus.fatigue')){
drawXAxis=!0;

this._setupFatiguePointFor(viewModel.lastKnownStatus.fatigue,viewModel,selectedNotificationType);
}else{
this._clearPlottedFatiguePoints(this._currentFatigueGroup);
}

if(drawXAxis){
this._drawXAxis();
}else if(this._axisGroup){
this._axisGroup.selectAll('*').remove();
this._axisDrawn=!1;
}
}

_setupFatiguePointFor(value,viewModel,selectedNotificationType){
const pointPlotData=[{value}];
const thresholdStatus=viewModel.thresholdStatusFor(selectedNotificationType);

this._drawFatiguePoints(this._currentFatigueGroup,pointPlotData,thresholdStatus);
}};


function _removeElement(){
if(typeof this.remove=='function'){
return this.remove();
}

if(_.exists(this.parentNode)){
return this.parentNode.removeChild(this);
}


}

const _existsAndIsANumber=value=>_.exists(value)&&!Number.isNaN(value);

module.exports=SparklineDirective;
//# sourceMappingURL=sparklineDirective.js.map
